import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// Models
import mCustomer from 'models/cpm/customer';
// HOCs
import withPermissions from 'hocs/WithPermissions';
// Custom
import { ONLY_ACTIVE_FILTER, ONLY_NON_ARCHIVED_FILTER } from 'constants/App';
import { fullListShape } from 'constants/PropTypesShapes';
import { cpmGetCarparkCustomersList } from 'actions';
import { buildListSpecs } from 'utils/Tools';
import SubListCardTemplate from 'components/templates/SubListCardTemplate';
import CustomerFilters from './CustomerFilters';
import CustomerRow from './CustomerRow';

class CustomerChooseList extends React.Component {
  constructor(props) {
    super(props);

    this.handleSelectCustomer = this.handleSelectCustomer.bind(this);
    this.handleSelectCustomers = this.handleSelectCustomers.bind(this);
    this.doGetRowComp = this.doGetRowComp.bind(this);

    // Build list specs: permanent and excluded filters
    const { permanentFiltersSpecs } = this.props;
    this.listSpecs = buildListSpecs(mCustomer.listFeatures.searchFields, permanentFiltersSpecs);
  }

  // Handlers
  handleSelectCustomer(customer) {
    if (customer) {
      const { onSelectCustomer } = this.props;
      onSelectCustomer(customer);
    }
  }

  handleSelectCustomers(selectedCustomers) {
    const { onSelectCustomer } = this.props;
    onSelectCustomer(selectedCustomers);
  }

  // Private
  doGetRowComp(props) {
    const {
      id, timezone, withChoose, withBooking, withParking,
    } = this.props;

    return (
      <CustomerRow
        {...props}
        id={id}
        timezone={timezone}
        withChoose={withChoose}
        withBooking={withBooking}
        withParking={withParking}
        withParkingAdd={false}
        withAccountActions={false}
        withColumnUser
        withColumnUserEmail
      />
    );
  }

  render() {
    const {
      id, withOnDemandCategory, fullWidth, customers,
      withSelection, withBooking, withParking, multiSelectable, withChoose, selectedCustomer, selectedCustomers,
      handleGetCustomersList,
    } = this.props;

    // List specs
    const { permanentFilters, excludedFilterFields } = this.listSpecs;

    // No entity filter if user has not multiple entities
    const finalExcludedFilterFields = [...(excludedFilterFields || [])];

    return (
      <SubListCardTemplate
        stickHeaderToTop
        withQueryParams={false}
        name={mCustomer.name}
        listFeatures={mCustomer.chooseListFeatures(withParking, withBooking)}
        withSelection={withSelection}
        withBooking={withBooking}
        withParking={withParking}
        multiSelectable={multiSelectable}
        withChoose={withChoose}
        chooseTooltipId="tooltip.chooseThisCarparkUser"
        onSelectElements={multiSelectable ? this.handleSelectCustomers : this.handleSelectCustomer}
        elementsData={{
          loading: customers.loading,
          selectedElement: selectedCustomer,
          selectedElements: selectedCustomers,
          elements: customers.elements,
          handleGetList: (p, s, f) => handleGetCustomersList({ carparkId: id }, p, s, f),
        }}
        permanentFilters={permanentFilters}
        excludedFilterFields={finalExcludedFilterFields}
        filtersComp={(
          <CustomerFilters
            id={id}
            withOnDemandCategory={withOnDemandCategory}
            fullWidth={fullWidth}
          />
        )}
        rowComp={this.doGetRowComp}
      />
    );
  }
}

CustomerChooseList.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  timezone: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
  customers: fullListShape.isRequired,
  withBooking: PropTypes.bool,
  withParking: PropTypes.bool,
  withChoose: PropTypes.bool,
  withOnDemandCategory: PropTypes.bool.isRequired,
  withSelection: PropTypes.bool,
  multiSelectable: PropTypes.bool,
  selectedCustomer: PropTypes.shape({ id: PropTypes.number.isRequired }),
  selectedCustomers: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number.isRequired })),
  permanentFiltersSpecs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    }),
  ),
  onSelectCustomer: PropTypes.func.isRequired,
  handleGetCustomersList: PropTypes.func.isRequired,
  hasPermission: PropTypes.func.isRequired, // eslint-disable-line react/no-unused-prop-types
};

CustomerChooseList.defaultProps = {
  fullWidth: true,
  withBooking: false,
  withParking: false,
  withChoose: false,
  withSelection: false,
  multiSelectable: false,
  permanentFiltersSpecs: null,
  selectedCustomer: null,
  selectedCustomers: null,
};

const mapStateToProps = (state) => ({
  customers: state.cpmCarparkCustomer.list,
  parkingCategories: state.cpmCarparkParkingCategory.list.elements,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleGetCustomersList: (data, pagination, sort, filters) => {
    dispatch(cpmGetCarparkCustomersList(mCustomer.queListCustomers(ownProps.hasPermission), data, { pagination, sort, filters: [...filters, ONLY_ACTIVE_FILTER, ONLY_NON_ARCHIVED_FILTER] }));
  },
});

module.exports = compose(
  withPermissions,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(CustomerChooseList);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/customers/CustomerChooseList.js